// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mimnX","rootNoMargin":"styles_rootNoMargin__3X040"};